import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { WebsiteCustomField } from '@rx-applications/clientsite/admin/utils';
import { LoadStatus } from '@rx-applications/shared/utils';
import { switchMap, tap, Observable  } from 'rxjs';
import { CustomFieldsBackendService } from '../backend/custom-field.backend';

interface CustomFieldsListState {
  customFields: WebsiteCustomField[];
  loading: LoadStatus;
  error: HttpErrorResponse | null;
}

const initialState: CustomFieldsListState = {
  customFields: [],
  loading: 'NOT_LOADED',
  error: null,
};

@Injectable({ providedIn: 'root' })
export class CustomFieldsListStore extends ComponentStore<CustomFieldsListState> {
  #customFieldsBackendService = inject(CustomFieldsBackendService);
  constructor() {
    super(initialState);
  }

  readonly websiteCustomFields$ = this.select((state) => state.customFields);
  readonly loading$ = this.select((state) => state.loading);
  readonly error$ = this.select((state) => state.error);

  readonly fetchWebsiteCustomFields = this.effect((request$: Observable<void>) =>
    request$.pipe(
      tap(() => this.loadingCustomFields),
      switchMap(() => this.#customFieldsBackendService.getCustomFieldsList()),
      tapResponse(
        (customFields: WebsiteCustomField[]) => this.handleCustomFieldsSucceeded(customFields),
        (error: HttpErrorResponse) => this.handleCustomFieldsFailed(error),
      ),
    ),
  );

  private loadingCustomFields = this.updater((state) => ({ ...state, loading: 'LOADING' }));

  private handleCustomFieldsSucceeded = this.updater((state, customFields: WebsiteCustomField[]) => ({
    ...state,
    loading: 'LOADED',
    customFields,
  }));

  private handleCustomFieldsFailed = this.updater((state, error: HttpErrorResponse) => ({
    ...state,
    loading: 'ERROR',
    error,
  }));

}
